/* Bundle maison — Douillette 4 saisons 2-en-1, Sovamia.
   🔴 Chaque douillette a SA couleur ET SA taille. Le prix du pack = la somme des tailles
   choisies moins une REMISE FIXE selon la quantité (la logique de lesdormeurs). Comme les
   prix finissent en ,90 et la remise aussi, tous les totaux retombent en ,90.
   Une ligne de panier par douillette + les taies offertes. On appelle le tiroir du thème. */
(function () {
  const racine = document.querySelector('[data-sdb]');
  if (!racine) return;
  const conf = JSON.parse(racine.querySelector('[data-sdb-config]').textContent);
  const bouton = racine.querySelector('[data-sdb-add]');
  const erreur = racine.querySelector('[data-sdb-err]');
  const T = conf.textes;

  let palier = conf.paliers.find((p) => p.defaut) || conf.paliers[0];
  const choix = [];                        // choix[i] = { couleur, taille }

  /* Shopify Markets convertit les prix rendus par Liquid, mais pas ceux écrits en dur. */
  const TAUX = (window.Shopify && window.Shopify.currency
                && parseFloat(window.Shopify.currency.rate)) || 1;
  const enDevise = (c) => Math.round(c * TAUX);

  const argent = (c) => {
    const n = (c / 100).toFixed(2);
    const virgule = /amount_with_comma_separator|amount_no_decimals_with_comma_separator/
      .test(conf.format);
    return conf.format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, virgule ? n.replace('.', ',') : n);
  };

  const laCouleur = (nom) => conf.couleurs.find((c) => c.nom === nom) || conf.couleurs[0];
  const laTaille = (cle) => conf.tailles.find((t) => t.cle === cle) || conf.tailles[0];
  const variante = (c, t) => conf.variantes.find((v) => v.couleur === c && v.taille === t);
  const unite = (i) => choix[i] || choix[0] ||
                       { couleur: conf.defaut.couleur, taille: conf.defaut.taille };

  const prixUnite = (u) => { const v = variante(u.couleur, u.taille); return v ? v.prix : conf.prix_defaut; };
  const barreUnite = (u) => { const v = variante(u.couleur, u.taille); return v ? (v.barre || v.prix) : conf.prix_defaut; };

  /* 🔴 Somme des tailles choisies − remise fixe. Marche pour N'IMPORTE QUELLE combinaison
     de tailles, et le total retombe toujours sur un ,90. */
  function total(n) {
    let brut = 0, plein = 0;
    for (let i = 0; i < n; i++) { brut += barreUnite(unite(i)); plein += prixUnite(unite(i)); }
    const r = conf.remises[String(n)] || 0;
    return { brut, net: Math.max(0, plein - enDevise(r)) };
  }

  /* Le prix de tête est rendu par Liquid : il ne bouge pas tout seul quand le bundle change
     de taille. On le réécrit donc nous-mêmes, sur la douillette 1. */
  function majTete() {
    const u = unite(0), p = prixUnite(u), b = barreUnite(u);
    const now = document.querySelector('[data-tete-now]');
    const was = document.querySelector('[data-tete-was]');
    const pct = document.querySelector('[data-tete-pct]');
    if (now) now.textContent = argent(p);
    if (was) { was.textContent = argent(b); was.hidden = b <= p; }
    if (pct) { pct.textContent = '\u2212' + Math.round((1 - p / b) * 100) + ' %'; pct.hidden = b <= p; }
  }

  function majPrix() {
    majTete();
    conf.paliers.forEach((p) => {
      const c = racine.querySelector('[data-sdb-tier="' + p.cle + '"]');
      if (!c) return;
      const t = total(p.qte);
      c.querySelector('[data-now]').textContent = argent(t.net);
      const was = c.querySelector('[data-was]'), eco = c.querySelector('[data-eco]');
      const gagne = t.brut > t.net;
      was.hidden = !gagne; eco.hidden = !gagne;
      if (gagne) {
        was.textContent = argent(t.brut);
        eco.textContent = T.economie.replace('{m}', argent(t.brut - t.net));
      }
    });
    const t = total(palier.qte);
    bouton.innerHTML = T.ajouter.replace('{prix}', argent(t.net)) +
      (t.brut > t.net ? '<s>' + argent(t.brut) + '</s>' : '');
  }

  /* ───────────── les champs : une couleur ET une taille par douillette */
  function champ(type, i, u) {
    const est = type === 'couleur';
    const t = laTaille(u.taille);
    return '<button type="button" class="sdb__f" data-f="' + type + '" data-i="' + i + '"' +
      ' aria-expanded="false">' +
      (est ? '<i class="sdb__f-dot" style="background:' + laCouleur(u.couleur).hex + '"></i>' : '') +
      '<span class="sdb__f-txt"><span class="sdb__f-lab">' + (est ? T.couleur : T.taille) +
      '</span><span class="sdb__f-val">' + (est ? u.couleur : t.nom) + '</span></span>' +
      '<i class="sdb__f-car"></i></button>';
  }

  function dessinePicks(p) {
    const zone = racine.querySelector('[data-sdb-picks="' + p.cle + '"]');
    zone.innerHTML = '';
    for (let i = 0; i < p.qte; i++) {
      if (!choix[i]) choix[i] = { couleur: conf.defaut.couleur, taille: conf.defaut.taille };
      const d = document.createElement('div');
      d.className = 'sdb__pick';
      d.innerHTML = (p.qte > 1 ? '<span class="sdb__no">' + T.unite + ' ' + (i + 1) + '</span>' : '') +
        '<div class="sdb__row">' + champ('couleur', i, choix[i]) + champ('taille', i, choix[i]) +
        '</div><div class="sdb__panel" data-panel hidden></div>';
      zone.appendChild(d);
    }
    const g = document.createElement('button');
    g.type = 'button'; g.className = 'sdb__guide'; g.dataset.sdbGuide = '';
    g.innerHTML = conf.icones.regle + T.guide;
    zone.appendChild(g);
  }

  function peint(i) {
    const u = choix[i];
    racine.querySelectorAll('[data-f="couleur"][data-i="' + i + '"]').forEach((b) => {
      b.querySelector('.sdb__f-dot').style.background = laCouleur(u.couleur).hex;
      b.querySelector('.sdb__f-val').textContent = u.couleur;
    });
    racine.querySelectorAll('[data-f="taille"][data-i="' + i + '"]').forEach((b) => {
      b.querySelector('.sdb__f-val').textContent = laTaille(u.taille).nom;
    });
  }

  /* ───────────── les menus */
  function fermeTout(sauf) {
    racine.querySelectorAll('[data-panel]').forEach((p) => { if (p !== sauf) p.hidden = true; });
    racine.querySelectorAll('.sdb__f').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  function ouvre(btn) {
    const type = btn.dataset.f, i = Number(btn.dataset.i);
    const panel = btn.closest('.sdb__pick').querySelector('[data-panel]');
    const deja = btn.getAttribute('aria-expanded') === 'true';
    fermeTout(panel);
    if (deja) { panel.hidden = true; return; }
    panel.innerHTML = type === 'couleur'
      ? '<span class="sdb__panel-t">' + T.couleur + '</span><ul class="sdb__opts">' +
        conf.couleurs.map((c) =>
          '<li><button type="button" class="sdb__opt" data-val="' + c.nom + '" aria-pressed="' +
          (c.nom === choix[i].couleur) + '" aria-label="' + c.nom + '">' +
          '<i class="sdb__opt-sw" style="background:' + c.hex + '"></i>' +
          '<span class="sdb__opt-nom">' + c.nom + '</span></button></li>').join('') + '</ul>'
      : '<span class="sdb__panel-t">' + T.taille + '</span>' +
        '<ul class="sdb__opts sdb__opts--taille">' + conf.tailles.map((t) =>
          '<li><button type="button" class="sdb__opt sdb__opt--taille" data-val="' + t.cle +
          '" aria-pressed="' + (t.cle === choix[i].taille) + '">' +
          '<b>' + t.nom + '</b><span>' + t.mesure + '</span>' +
          (t.lit ? '<i>' + t.lit + '</i>' : '') + '</button></li>').join('') + '</ul>';
    panel.hidden = false;
    panel.dataset.type = type; panel.dataset.i = String(i);
    btn.setAttribute('aria-expanded', 'true');
  }

  /* ───────────── piloter le picker natif (masqué)
     C'est lui qui fait filtrer la galerie SUR LA COULEUR, et c'est lui qui met à jour le prix
     affiché en haut de page. On lui passe donc la couleur ET la taille de la douillette 1,
     sinon le prix de tête reste figé sur la plus petite taille. */
  function coche(valeur) {
    const zone = document.querySelector('variant-selects, variant-radios, .product-form__input');
    if (!zone || !valeur) return;
    const r = zone.querySelector('input[type="radio"][value="' + CSS.escape(valeur) + '"]');
    if (r) {
      if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const sels = document.querySelectorAll('variant-selects select, variant-radios select');
    sels.forEach((s) => {
      if (s.value !== valeur && [...s.options].some((o) => o.value === valeur)) {
        s.value = valeur; s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function pilotePicker() {
    const u = unite(0);
    coche(u.couleur);
    coche(u.taille);
  }

  /* ───────────── les clics */
  racine.addEventListener('click', (e) => {
    const opt = e.target.closest('.sdb__opt');
    if (opt) {
      const panel = opt.closest('[data-panel]');
      const i = Number(panel.dataset.i);
      choix[i][panel.dataset.type] = opt.dataset.val;
      peint(i);
      if (i === 0) pilotePicker();        // la tête suit la douillette 1
      fermeTout();
      erreur.classList.remove('est-visible');
      majPrix();
      return;
    }
    const f = e.target.closest('.sdb__f');
    if (f) { ouvre(f); return; }
    if (e.target.closest('[data-sdb-guide]')) {
      const g = document.querySelector('[data-sdb-modale]');
      if (g) g.classList.add('est-ouvert');
      return;
    }
    const lab = e.target.closest('.sdb__lab');
    if (lab) {
      const tier = lab.closest('[data-sdb-tier]');
      palier = conf.paliers.find((p) => p.cle === tier.dataset.sdbTier);
      racine.querySelectorAll('[data-sdb-tier]').forEach((t) => {
        const choisi = t === tier;
        t.classList.toggle('est-choisi', choisi);
        t.querySelector('input').checked = choisi;
        t.querySelector('[data-sdb-picks]').hidden = !choisi;
      });
      fermeTout();
      dessinePicks(palier);
      erreur.classList.remove('est-visible');
      majPrix();
    }
  });

  document.addEventListener('click', (e) => { if (!racine.contains(e.target)) fermeTout(); });

  /* ───────────── le guide des tailles, déplacé dans <body> */
  const guide = racine.querySelector('[data-sdb-modale]');
  if (guide) {
    document.body.appendChild(guide);
    const ferme = () => guide.classList.remove('est-ouvert');
    guide.querySelector('[data-sdb-fond]').addEventListener('click', ferme);
    guide.querySelector('[data-sdb-x]').addEventListener('click', ferme);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') ferme(); });
  }

  /* ───────────── ajout au panier */
  let enCours = false;                      // verrou : sinon le cadeau part en double

  bouton.addEventListener('click', async () => {
    if (enCours) return;
    const n = palier.qte, items = [], resume = [];
    for (let i = 0; i < n; i++) {
      const u = choix[i], v = variante(u.couleur, u.taille);
      if (!v) {
        erreur.textContent = T.indispo.replace('{n}', i + 1);
        erreur.classList.add('est-visible');
        return;
      }
      const ta = laTaille(u.taille);
      resume.push(T.unite + ' ' + (i + 1) + ' : ' + u.couleur + ' / ' + ta.nom);
      items.push({ id: v.id, quantity: 1, properties: {
        [T.couleur]: u.couleur, [T.taille]: ta.nom + ' (' + ta.mesure + ')',
        _offre: palier.cle } });
    }
    if (conf.cadeau && conf.cadeau.id) {
      items.push({ id: conf.cadeau.id, quantity: 2 * n,
        properties: { _pour: resume.join(' · '), _offre: palier.cle } });
    }

    erreur.classList.remove('est-visible');
    enCours = true; bouton.disabled = true;
    const avant = bouton.innerHTML;
    bouton.textContent = T.en_cours;
    try {
      const drawer = document.querySelector('cart-drawer');
      const corps = { items: items.slice().reverse() };  // la dernière ajoutée s'affiche en premier
      if (drawer && drawer.getSectionsToRender) {
        corps.sections = drawer.getSectionsToRender().map((s) => s.id);
        corps.sections_url = window.location.pathname;
      }
      const rep = await fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps) });
      if (!rep.ok) throw new Error('ajout refusé');
      const data = await rep.json();
      if (drawer && drawer.renderContents) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (drawer.open) drawer.open();      // renderContents n'ouvre pas le tiroir tout seul
      } else {
        window.location.href = (window.routes ? window.routes.cart_url : '/cart');
        return;
      }
      if (window.publish && window.PUB_SUB_EVENTS) {
        const panier = await (await fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')).json();
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sdb', cartData: panier });
      }
    } catch (e) {
      window.location.href = (window.routes ? window.routes.cart_url : '/cart');
    } finally {
      enCours = false; bouton.disabled = false; bouton.innerHTML = avant; majPrix();
    }
  });

  /* ───────────── départ */
  conf.paliers.forEach((p) => dessinePicks(p));
  racine.querySelectorAll('[data-sdb-tier]').forEach((t) => {
    const choisi = t.dataset.sdbTier === palier.cle;
    t.classList.toggle('est-choisi', choisi);
    t.querySelector('input').checked = choisi;
    t.querySelector('[data-sdb-picks]').hidden = !choisi;
  });
  const gw = racine.querySelector('[data-gift-was]');
  if (gw && conf.cadeau && conf.cadeau.valeur) {
    gw.textContent = argent(enDevise(conf.cadeau.valeur));
  }
  majPrix();
  pilotePicker();
})();
